import React from 'react';
import { renderComponent } from '../DynamicPage';

interface ImageProps {
    src?: any,
    width?: number | string
}

const Cell: React.FC<ImageProps> = ({ src, width}) => {
    return (

        <div className="flex items-center justify-center">
            <img src={src} width={width} alt="Imagen" className="max-w-full max-h-full"/>
        </div>

    );
};

export default Cell;